export class NotFoundError extends Error {
  constructor(entity: string = "Resource") {
    super(`${entity} not found`);
    this.name = "NotFoundError";
  }
}
